import { render, staticRenderFns } from "./ReservationsBookPayment.vue?vue&type=template&id=17d916d0&scoped=true"
import script from "./ReservationsBookPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationsBookPayment.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReservationsBookPayment.vue?vue&type=style&index=0&id=17d916d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d916d0",
  null
  
)

export default component.exports